module.exports = __webpack_public_path__ + "static/media/ticket-icon.7e4dec00.svg";